'use client';

import { createContext, useContext, useEffect, useState } from 'react';

type AuthContextType = {
  isAuth: boolean;
  setIsAuth: (value: boolean) => void;
  refreshAuth: () => Promise<void>;
};

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [isAuth, setIsAuth] = useState(false);

  const refreshAuth = async () => {
    const res = await fetch('/api/cookies');
    const data = await res.json();
    setIsAuth(data.isAuth);
  };

  useEffect(() => {
    refreshAuth();
  }, []);

  return (
    <AuthContext.Provider value={{ isAuth, setIsAuth, refreshAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
